import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of as rxOf } from "rxjs/observable/of";
import { tap } from "rxjs/operators";
import { GLTF } from "../webgl2/webgl2-token";
var BufferLoader = (function () {
    function BufferLoader(http_client_, gltf_data_) {
        this.http_client_ = http_client_;
        this.gltf_data_ = gltf_data_;
        this.buffer_cache_ = [];
    }
    BufferLoader.prototype.getBuffer = function (buffer_index) {
        return this.buffer_cache_[buffer_index];
    };
    ;
    ;
    BufferLoader.prototype.loadBuffer = function (buffer_index) {
        var _this = this;
        var buffer = this.buffer_cache_[buffer_index];
        if (buffer) {
            return rxOf(buffer);
        }
        var uri = this.gltf_data_.buffers[buffer_index].uri;
        if (typeof uri === "string") {
            var scheme = uri.split(";");
            if (scheme[0] === "data:application/octet-stream") {
                var data = uri.split(",")[1];
                var is_base_64 = scheme[1].split(",")[0] === "base64";
                var buffer_1 = this.decodeDataURI(data, is_base_64);
                this.buffer_cache_[buffer_index] = buffer_1;
                return rxOf(buffer_1);
            }
            else {
                return this.http_client_.get(uri, { responseType: "arraybuffer" })
                    .pipe(tap(function (buffer) {
                    _this.buffer_cache_[buffer_index] = buffer;
                }));
            }
        }
        else {
        }
    };
    ;
    BufferLoader.prototype.decodeDataURI = function (data, is_base_64) {
        var decoded_text = decodeURIComponent(data);
        var byte_string = decoded_text;
        if (is_base_64) {
            byte_string = atob(decoded_text);
        }
        var array = new Uint8Array(byte_string.length);
        for (var i = 0; i < byte_string.length; i++) {
            array[i] = byte_string.charCodeAt(i);
        }
        return array.buffer;
    };
    ;
    BufferLoader.decorators = [
        { type: Injectable },
    ];
    BufferLoader.ctorParameters = function () { return [
        { type: HttpClient, },
        { type: undefined, decorators: [{ type: Inject, args: [GLTF,] },] },
    ]; };
    return BufferLoader;
}());
export { BufferLoader };
//# sourceMappingURL=buffer-loader.js.map